import { HttpInterceptorFn } from '@angular/common/http';
import { HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { StorageKeys } from '@core-interfaces/global';
import { Observable } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  // Si el request ya trae su propio Authorization (ej. token de reset de
  // contraseña de un usuario sin sesión activa), no se sobreescribe con la
  // sesión del navegador (POLAR-723).
  if (req.headers.has('Authorization')) {
    return next(req);
  }

  const token = sessionStorage.getItem(StorageKeys.session_token);

  if (token) {
    const clonedRequest = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
    return next(clonedRequest);
  }

  return next(req);
};
